export default __webpack_public_path__ + "static/media/screen15.644264b4.svg";